export default {
  //URL_CONFIG: "/config/frontend.json",
  URL_CONFIG: "https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/corrivium-demo/config/frontend.json",
  BITMOVIN_PLAYER_KEY: "3d9080ce-6734-44e3-8344-6a20769f2c30",
  BITMOVIN_ANALYTICS_KEY: "ade734cd-842a-4308-b630-9d3c3b709ce0",
  S3_REGION: "ap-southeast-2",
  S3_BUCKET: "events-public-assets",
  COGNITO_REGION: "ap-southeast-2",
  COGNITO_USER_POOL_ID: "ap-southeast-2_ILF1tEtGD",
  COGNITO_APP_CLIENT_ID: "7saccp804ckf8uh0khdag69u96",
  COGNITO_IDENTITY_POOL_ID: "ap-southeast-2:826828ad-3f94-4be4-8d11-7f10a4b70ae9",
  BACKEND_REGION: "ap-southeast-2",
  BACKEND_URL: ""
}